import React, { useEffect, useState } from 'react';
import { Subheader } from 'new/elements/Subheader';
import { ChipBadge } from 'new/elements/ChipBadge';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ROUTE_COLLABORATE_RESOURCE_ID } from 'new/constants/pathnames';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { useHistory } from 'react-router-dom';
import { useResource } from 'new/components/monitor/ResourceTriage/useResource';
import { ResourceSearch } from 'new/elements/ResourceSearch';
import { useDispatch } from 'react-redux';
import { CenteredLoader } from 'new/elements/CenteredLoader';
import {
  RESOURCE_TYPE_CREDENTIALS,
  RESOURCE_TYPE_DATA_MAP,
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_FLOW,
  RESOURCE_TYPE_SCHEMA_SPECS,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_SOURCE,
} from 'js/constants/resourceTypes';
import {
  ACL_RESOURCE_TYPE_CREDENTIALS,
  ACL_RESOURCE_TYPE_DATASET,
  ACL_RESOURCE_TYPE_DESTINATION,
  ACL_RESOURCE_TYPE_DF_DATASET,
  ACL_RESOURCE_TYPE_FLOW,
  ACL_RESOURCE_TYPE_LOOKUPS,
  ACL_RESOURCE_TYPE_SCHEMA_TEMPLATE,
  ACL_RESOURCE_TYPE_SOURCE,
} from 'js/constants/aclConstants';
import { useDrawerContext } from 'new/components/drawer/useDrawerContext';
import { useCurrentOrg } from 'new/hooks/adapters/useCurrentOrg';
import { useAppContext } from 'new/hooks/useAppContext';
import { ResourceCollaboration } from 'new/elements/ResourceCollaboration';
import { resourceTypes } from 'new/elements/ResourceSearch/ResourceSearch';

interface ResourceDetailProps {}

export const aclTypes = {
  [RESOURCE_TYPE_CREDENTIALS]: ACL_RESOURCE_TYPE_CREDENTIALS,
  [RESOURCE_TYPE_FLOW]: ACL_RESOURCE_TYPE_FLOW,
  [RESOURCE_TYPE_SOURCE]: ACL_RESOURCE_TYPE_SOURCE,
  [RESOURCE_TYPE_DATA_MAP]: ACL_RESOURCE_TYPE_LOOKUPS,
  [RESOURCE_TYPE_SINK]: ACL_RESOURCE_TYPE_DESTINATION,
  [RESOURCE_TYPE_DATA_SET]: ACL_RESOURCE_TYPE_DATASET,
  [RESOURCE_TYPE_SCHEMA_SPECS]: ACL_RESOURCE_TYPE_SCHEMA_TEMPLATE,
};

export const ResourceDetail: ScreenComponent<ResourceDetailProps> = (
  props: ResourceDetailProps,
) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const org = useCurrentOrg();
  const initialParams = new URLSearchParams(history.location.search);
  const [data, setData] = useState({
    type: initialParams.get('type'),
    id: initialParams.get('id'),
  });
  const { drawerContentRef } = useDrawerContext();
  const { resource, loading } = useResource(data.type, data.id);
  const { setCurrentSlug } = useAppContext();

  useEffect(() => {
    if (data.id && data.type && !resource && !loading) {
      const action = resourceTypes.find((r) => r.value === data.type)?.action;
      if (action) {
        dispatch(action(data.id));
      }
    }
  }, []);

  function updateUrl(data) {
    const params = new URLSearchParams();
    params.set('type', data.type);
    params.set('id', data.id);
    history.replace({
      pathname: history.location.pathname,
      search: params.toString(),
    });
  }

  useEffect(() => {
    if (resource) {
      setCurrentSlug(resource.name);
    }
  }, [resource]);

  const onResourceSearched = (data) => {
    setData(data);
    updateUrl(data);
  };

  if (loading) {
    return <CenteredLoader />;
  }

  if (!resource) {
    return null;
  }

  return (
    <div>
      <Subheader
        title={resource.name}
        subtitle={<ChipBadge label={'ID: ' + resource.id} color="success" />}
        RightComponent={
          <ResourceSearch onSearch={onResourceSearched} id={data.id} type={data.type} />
        }
      />
      <ResourceCollaboration
        parentScrollRef={drawerContentRef}
        resourceType={data.type}
        resourceId={data.id}
      />
    </div>
  );
};

ResourceDetail.screenConfig = {
  header: {
    title: 'Collaborate',
    slugTitle: 'Collaboration 360',
  },
  path: `${ROUTE_REDESIGN}${ROUTE_COLLABORATE_RESOURCE_ID}`,
  screenName: 'ResourceDetail',
  domain: 'collaborate',
};
